import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  div {
    font-size: 13px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.gray[900]};
    word-break: break-word;
    white-space: pre-wrap;
  }
`;
